/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchQuestion } from '../../models/match-question';

export interface GetMatchQuestion$Params {
  id: string;
}

export function getMatchQuestion(http: HttpClient, rootUrl: string, params: GetMatchQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchQuestion>> {
  const rb = new RequestBuilder(rootUrl, getMatchQuestion.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchQuestion>;
    })
  );
}

getMatchQuestion.PATH = '/matchquestion/{id}';
